import { Checkbox, Space } from "antd"
import classNames from "classnames"
import PropTypes from "prop-types"
import { Text } from "ui/Typography"
import { DAYS } from "../../utils/constants"
import styles from "./DaySelector.module.css"
import { useDispatch, useSelector } from "react-redux"
import { updatedAvailableDays } from "store/trips"
import { setFormValues, setFormTouched } from "store/proNewListingForms"

const allDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
]

export const DaySelector = ({ form, selectedDays, setSelectedDays }) => {
  const dispatch = useDispatch()
  const formScheduling = useSelector((state) => state.proNewListingForms.scheduling)

  const handleDayToggle = (day) => {
    const newData = selectedDays?.includes(day) ? selectedDays?.filter((d) => d !== day) : [...selectedDays, day]
    setSelectedDays(newData)
    const daysObject = allDays.reduce((acc, day) => {
      acc[day] = newData.includes(day)
      return acc
    }, {})
    form.setFieldsValue({ available_days: daysObject })
    dispatch(updatedAvailableDays(daysObject))

    // Update Redux store for tab switch validation
    dispatch(setFormValues("scheduling", {
      ...formScheduling?.values,
      available_days: daysObject
    }))

    // Mark form as touched so validation runs on tab switch
    if (!formScheduling?.touched) {
      dispatch(setFormTouched("scheduling", true))
    }
  }

  return (
    <Space size="small" className={styles.daySelector}>
      {DAYS.map((day) => (
        <div key={day.value} className="flex-column align-center">
          <div
            className={classNames(
              styles.dayItem,
              selectedDays.includes(day.value) && styles.selected
            )}
            onClick={() => handleDayToggle(day.value)}
          >
            <Text varian="sub">{day.label}</Text>
          </div>
          <Checkbox
            checked={selectedDays.includes(day.value)}
            onChange={() => handleDayToggle(day.value)}
            className={styles.dayCheckbox}
          />
        </div>
      ))}
    </Space>
  )
}

DaySelector.propTypes = {
  form: PropTypes.object.isRequired,
  selectedDays: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedDays: PropTypes.func.isRequired,
}

export default DaySelector